export default __webpack_public_path__ + "static/media/2photo(new).8af1a272.jpg";